module.exports = __webpack_public_path__ + "img/Insulation servicies on the oil rig platform.603eee87.png";